__turbopack_context__.v({
  "card": "hover-state-module-scss-module__U79tCq__card",
});
